import {IconBox, IconProps} from "../index";
import React from "react";

import TelegramSvg from "../../../../assets/icons/social/telegram.svg?react";

export const TelegramIcon = (props: IconProps) => {
    return (
        <IconBox {...props}>
            <TelegramSvg/>
        </IconBox>
    );
}
